import styled, { css } from "styled-components";

const Wrapper = styled.div(({ theme }) => css`
  display: flex;
  justify-content: space-between;
  width: 100%;

  .dashboard-content-group {
    margin: none;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    @media only screen and (min-width: ${theme.breakpoints.XM}) {
      margin: 0 10px;
    }
  }

  .desktop-nav-left, .desktop-nav-right {
    display: none;
    height: 100vh;
    background: ${theme.palette.header.background};

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      display: block;
    }
  }

  .nav-left-desktop {
    display: none;

    @media only screen and (min-width: ${theme.breakpoints.XM}) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .nav-right-desktop {
    display: none;

    @media only screen and (min-width: ${theme.breakpoints.XM}) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
`);

export default Wrapper;
